<template>
    <div class="sticker-list-wrap">
        <el-card class="sticker-list-body" >
            <span style="font-size: 25px">设置溯源商品（奇葩熊）</span>
            <br>
            <span style="color: orange">提示：海际它品的商品溯源设置在它品后台，此处为奇葩熊使用</span>
          <!-- 筛选区域 -->
            <el-form :inline="true" size="mini" class="demo-form-inline" style="float:right;">
              <el-form-item label="" >
              <el-select v-model="selects.type"  size="mini" placeholder="是否启用" clearable  class="sticker-select">
                <el-option
                    v-for="item in typeList"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                </el-option>
              </el-select>
              </el-form-item>
                <el-form-item label="" >
                    <el-input
                            placeholder="gspid"
                            class="sticker-select-input"
                            size="mini"
                            v-model="selects.gspid"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input
                            placeholder="商品名称"
                            class="sticker-select-input"
                            size="mini"
                            v-model="selects.subject"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="getSelects">筛选</el-button>
<!--                    <el-button size="mini" @click="reset">重置</el-button>-->
                </el-form-item>
            </el-form>
            <!-- 表格区域 -->
            <el-table
                    class="page-wrap"
                    :data="dataList"
                    ref="listTable"
                    row-key="relation_id"
                    header-row-class-name="table-black-header"
                    style="width: 100%"
            >
              <el-table-column label="GSPID"  prop="code"></el-table-column>
              <el-table-column  label="商品名称"  prop="subject" align="center"  min-width="120"></el-table-column>
              <el-table-column label="所属平台" prop="platfrom_name">
                <span slot-scope="scope" v-if="scope.row.fromway == 8">奇葩熊</span>
                <span v-else>其他</span>
              </el-table-column>
                <el-table-column label="商品图片" min-width="100">

                  <template slot-scope="scope">
                    <img :src="getImage(scope.row.photo)" alt="" width="150" >
                  </template>
                </el-table-column>
              <el-table-column label="是否启用溯源" >
                <span slot-scope="scope" v-if="scope.row.trace>0">是</span>
                <span v-else>否</span>
              </el-table-column>
                <el-table-column label="更新信息" min-width="160">
                    <template slot-scope="scope" >
                      <div>更新人：{{ scope.row.logInfo ? scope.row.logInfo.name : '-' }}</div>
                      <div>更新时间：{{ scope.row.logInfo ? scope.row.logInfo.updatetime : '-' }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="setTrace(scope.row.code,0)">停用</el-button>
                        <el-button type="text" size="mini" @click="setTrace(scope.row.code,1)">启用</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--页码信息-->
            <div class="ftc mt10">
                <el-pagination
                        background
                        layout="total, prev, pager, next, jumper"
                        :total="page.total"
                        :page-size="page.pageSize"
                        @current-change="currentPageChange"
                ></el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
    import {stickerApi} from "@/api/sticker";

    export default {
        data() {
            return {
                page: {
                    currentPage: 1,
                    pageSize: 50,
                    total: 0
                },
                selects: {
                    gspid: '',
                    subject: '',
                    type:1,
                },
                typeList: [
                  {value: 1, text: "启用"},
                  {value: 2, text: "停用"}
                ],
                dataList: [],
            };
        },
        mounted() {
            this.getList();
        },
        methods: {
            /**
             * 获取贴纸列表
             */
            getList() {
                const pam = {
                    page: this.page.currentPage,
                    per_page: this.page.pageSize,
                    gspid: this.selects.gspid,
                    subject: this.selects.subject,
                    trace: this.selects.type
                };

                this.$EpetJs.Common.get(stickerApi.getQipaGoodsListUrl, pam, {
                    needLoading: true
                }).then(res => {
                  this.dataList = res.data.data;
                    this.page.total = res.data.meta.pagination.total;
                    this.page.currentPage = res.data.meta.pagination.current_page;
                });
            },
          //设置商品是否溯源
          setTrace(gspid,type) {
            this.$confirm('请确认是否要设置商品溯源', '提醒', {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              const pam = {
                gspid: gspid,
                type: type,
                platform_id: 8
              };
              this.$EpetJs.Common.post(stickerApi.setQipaGoodsTraceUrl, pam, {
                needLoading: true
              }).then(res => {
                if (res.data.data.status_code == 200) {
                  this.$message.success("设置成功！");
                } else {
                  this.$message.error("设置失败！");
                }
                this.getList()
              });
            }).catch(() => {
            });
          },
            /**
             * 当前页改变
             */
            currentPageChange(val) {
                this.page.currentPage = val;
                this.getList();
            },
            /**
             * 筛选
             */
            getSelects() {
                this.page.currentPage = 1;
                this.getList();
            },
          getImage(url) {
            return 'https://epetfile-download.oss-cn-hangzhou.aliyuncs.com/' + url
          }
        }
    };
</script>
<style lang="less">
    .sticker-select-input,
    .sticker-select {
        width: 110px;
    }

    .sticker-list-wrap {
        .sticker-list-body {
            min-height: calc(100vh - 60px);

            .delete-icon {
                color: #000;
                font-size: 20px;
                vertical-align: middle;
            }

            .detail-icon {
                color: #000;
                font-size: 20px;
                vertical-align: middle;
            }
        }
    }
</style>
